import React from "react";

import Header from "components/Header";
import styles from "components/pages/Requirements.scss";
import Field from "components/project_form/Field";
import HelpBar from "components/projects/HelpBar";
import Section from "components/projects/requirement/Section";
import { useAnswerContext } from "contexts/answerContext";
import { useGuide } from "queries/guides";
import { useRequirement } from "queries/requirements";

import Step from "../requirement/Step";
import * as Layout from "./Layout";

// TODO: Next button submits application and takes applicant to a explination page
const ZoningVerificationPage = () => {
  const { record: project } = useAnswerContext();
  const { data: guide } = useGuide(project.guide_id);
  const { data: requirement } = useRequirement(project.requirement_ids[0]);
  const { sections } = requirement;

  return (
    <Layout.Page name="zoning-verification">
      <Header hideTitle />
      <Layout.Main>
        <Layout.Content>
          <div className={styles.sectionsContainer}>
            <Step header={guide?.header_title} instructions={guide?.message} />

            <Field fieldIdentifier="field:project_type" behaviorType="inline" />
            <Field fieldIdentifier="field:address" behaviorType="inline" withoutUseCodeConditions />
            <div className={styles.sectionsContainer}>
              {sections.map((section) => (
                <Section section={section} key={section.name} />
              ))}
            </div>
          </div>
        </Layout.Content>
        <HelpBar />
      </Layout.Main>
    </Layout.Page>
  );
};

export default ZoningVerificationPage;
